import Checkbox from 'antd/lib/checkbox';
import ConfigProvider from 'antd/lib/config-provider';

type CheckboxProps = {
  checked?: boolean;
  disabled?: boolean;
  onCheck: () => void;
  label?: string;
};

const StyledCheckbox = ({
  checked = undefined,
  onCheck,
  label = '',
  disabled = false,
}: CheckboxProps) => (
  <ConfigProvider
    theme={{
      token: {
        colorPrimary: '#1ab8c9',
        controlInteractiveSize: 28,
        lineWidth: 1,
        lineHeight: 1.5,
        fontSize: 16,
        fontFamily: '"Inter", sans-serif',
      },
    }}
  >
    <Checkbox
      className={`w-full ${disabled ? 'pointer-events-none' : ''}`}
      onClick={onCheck}
      disabled={disabled}
      checked={checked}
    >
      {label}
    </Checkbox>
  </ConfigProvider>
);

export default StyledCheckbox;
